import React from 'react';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import { Col } from 'antd';

const RoomsResponsibleForm = ({ departments, persons }) => {
  const { t } = useTranslation();

  return (
    <>
      <CollapseBlock>
        <Col span={6}>
          <FormSelect
            label={t('Pracovisko')}
            name={'department_id'}
            options={departments}
            rules={[required(t)]}
            disabled
          />
        </Col>
        <FormSelect
          label={t('Zodpovedné osoby')}
          mode={'multiple'}
          name={'person_ids'}
          options={persons}
          extra={t('Môžete vybrať viac zodpovedných osôb naraz')}
          rules={[required(t)]}
        />
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'room-responsible'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </CollapseBlock>
    </>
  );
};

RoomsResponsibleForm.propTypes = {
  props: PropTypes.any,
  departments: PropTypes.array,
  persons: PropTypes.array,
};
export default RoomsResponsibleForm;
